import { Quaternion } from 'three';
import { H3BasicMaterial } from '../../../materials/basic/h3-basic-material';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { Location } from '../../../task-data/sensor-location';
import { REFERENCE_AXIS } from '../../../utils/point-cloud-utils';
import { RendererLayer, setRendererLayers } from '../../render-utils';
import {
  AbstractMeshHelper,
  ConfigureMeshesConfiguration,
} from '../abstract-mesh-helper';
import { ArrowMesh } from '../arrow-mesh';
import {
  getOutlinedSphereMaterialParameters,
  OutlinedSphere,
} from '../outlined-sphere';

const sensorColor = '#ABEBD1';
const sensorRadius = 0.4;

export class SensorIndicatorHelper extends AbstractMeshHelper {
  private sensor: OutlinedSphere;
  private arrow: ArrowMesh;

  constructor() {
    super();
    this.sensor = new OutlinedSphere(sensorRadius);

    this.arrow = new ArrowMesh({
      direction: [...REFERENCE_AXIS],
      radius: 0.04,
      headLength: sensorRadius / 2,
      headWidth: sensorRadius / 2,
    });
    this.sensor.add(this.arrow);

    this.sensor.name = 'SensorIndicator';
  }

  updatePosition(location: Location) {
    this.sensor.position.fromArray(location.position);
    this.sensor.rotation.setFromQuaternion(
      new Quaternion().fromArray(location.rotation),
    );
  }

  dispose() {
    this.sensor.dispose();
    this.arrow.dispose();
  }

  getMeshes() {
    return [this.sensor];
  }

  protected override updateRendererLayers(_state: PointCloudContentState) {
    setRendererLayers([RendererLayer.Main], this.sensor);
  }

  protected override configureMeshes({
    materialService,
  }: ConfigureMeshesConfiguration) {
    const materialProperties = getOutlinedSphereMaterialParameters({
      color: sensorColor,
      opacity: 0.6,
    });
    const sensorMaterial = materialService.get(
      H3BasicMaterial,
      materialProperties.sphere,
    );
    const outlineMaterial = materialService.get(
      H3BasicMaterial,
      materialProperties.outline,
    );

    this.sensor.setMaterial(sensorMaterial);
    this.arrow.setMaterial(outlineMaterial);
  }
}
